import { render, staticRenderFns } from "./marcasFilters.vue?vue&type=template&id=5bab4f83"
import script from "./marcasFilters.vue?vue&type=script&lang=js"
export * from "./marcasFilters.vue?vue&type=script&lang=js"
import style0 from "./marcasFilters.vue?vue&type=style&index=0&id=5bab4f83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports